import React, { useContext } from 'react';

import { PlayerContext } from '../../../contexts/player.context';

import { Select } from './PlaybackSpeed.styles';

const PlaybackSpeed = () => {
  const { playbackRate, setPlaybackRate } = useContext(PlayerContext);

  const handleChange = e => {
    setPlaybackRate(e.target.value);
  };

  return (
    <div style={{ paddingBottom: '2px' }}>
      <Select onChange={handleChange} value={playbackRate}>
        <option value={0.5}>0.5x</option>
        <option value={0.75}>0.75x</option>
        <option value={1}>1.0x</option>
        <option value={1.25}>1.25x</option>
        <option value={1.5}>1.5x</option>
        <option value={2}>2.0x</option>
        <option value={2.25}>2.25x</option>
        <option value={2.5}>2.5x</option>
      </Select>
    </div>
  );
};

export default PlaybackSpeed;
